"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = require("react");
var antd_1 = require("antd");
var locale_1 = tslib_1.__importDefault(require("../locale"));
var context_1 = require("../context");
var LoadingIndicator = function (_a) {
    var _b = _a.duration, duration = _b === void 0 ? 3 : _b;
    var tableCtx = (0, context_1.useTableContext)();
    (0, react_1.useEffect)(function () {
        antd_1.message.loading({
            key: "loading-message",
            content: tableCtx.fetchingRecordsMsg,
            duration: duration,
        });
        return function () {
            antd_1.message.destroy("loading-message");
        };
    }, [duration, locale_1.default.fetchingRecordsMsg]);
    return null;
};
exports.default = LoadingIndicator;
//# sourceMappingURL=spinner.js.map